import { Star } from 'lucide-react';
import clsx from 'clsx';

/**
 * Renders a row of star icons for a given rating (1–5).
 */
export function StarRating({ rating = 5, size = 16 }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }, (_, i) => (
        <Star
          key={i}
          size={size}
          className={clsx(
            i < rating ? 'text-warning fill-warning' : 'text-ui-border'
          )}
        />
      ))}
    </div>
  );
}
